<style lang="scss" scoped>
.navigation {
    position: relative;
    z-index: 223;
    background-size: 100%;
    background: {
        size: auto 100%;
        color:  #505060;
        repeat: no-repeat;
    }
}
header {
    line-height: 1;
    width: 100%;
    height: 72px;
    padding: 0 26px 0 14px;
    color: white;
    .logo {
        width: 153px;
        height: 40px;
        text-decoration: none;
        vertical-align: middle;
        display: inline-block;
        margin-top: 14px;
        background: {
            image: url('../assets/image/logo2.png');
            size: 100%;
        }
    }
    .search-control {
        margin: 21px 0 0 40px;
        height: 30px;
        border-radius: 4px;
        overflow: hidden;
        width: 278px;
        background-color: #e3e3e3;
        font-size: 0;
        input {
            border: 0;
            border: none;
            height: 30px;
            font-size: 14px;
            width: 244px;
            padding-right: 10px;
            background-color: #e3e3e3;
        }
        .addon {
            width: 34px;
            height: 100%;
            padding: 8px 5px;
        }
    }
    .setting {
        margin: 0 20px;
        // position: relative;
        display: inline-block;
        line-height: 72px;
        font-size: 12px;
        cursor: pointer;
        position: relative;
        &:hover {
            .tip {
                display: block;
            }
        }
        > .icons {
            margin-top: -2px;
        }
        .tip {
            position: absolute;
            top: 61px;
            display: none;
            text-align: center;
            right: 0;
            font-size: 12px;
            color: white;
            height: 26px;
            line-height: 26px;
            width: 178px;
            border-radius: 2px;
            background-color: #ecbb45;
        }
    }
    .info {
        display: inline-block;
        line-height: 72px;
        font-size: 12px;
        cursor: pointer;
        position: relative;
        .avatar {
            vertical-align: middle;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            border: 1px solid white;
            margin-right: 8px;
        }
    }
    .feedback {
        font-size: 14px;
    }
}
nav {
    width: 100%;
    height: 36px;
    border-bottom: 1px solid #d0d0d0;
    ul {
        position: relative;
        font-size: 0;
        height: 100%;
    }
    .tab {
        height: 100%;
        line-height: 36px;
        display: inline-block;
        background-color: #d0d0d0;
        font-size: 14px;
        color: black;
        width: 190px;
        text-align: center;
        cursor: pointer;
        &.active {
            background-color: #909098;
            color: white;
        }
        &:first-child {
            margin: 0 7px 0 6px;
            border-radius: 4px 4px 0 0;
            border: none;
        }
        &:nth-child(2) {
            border-top-left-radius: 4px;
            border: none;
        }
        &:last-child {
            border-top-right-radius: 4px;
        }
        border-left: 1px solid #909098;
    }
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.dropmenu {
    width: 325px;
    height: 281px;
    position: absolute;
    z-index: 999;
    top: 61px;
    cursor: default;
    background-color: white;
    // left: 50%;
    border-radius: 2px;
    // margin-left: -162px;
    right: 0;
    overflow: hidden;
    // box-shadow: 1px 1px 5px #ccc, -1px 0 5px #ccc;
    // box-shadow: 0 4px 10px rgba(0, 0, 0, 0.4);
    box-shadow: 2px 2px 9px rgba(0,0,0,.5);
    .base-info {
        height: 119px;
        padding: 34px 17px 0 97px;
        border-bottom: 1px solid #e8e8e8;
        line-height: 1;
        position: relative;
        .nickname {
            font-size: 17px;
            color: black;
            margin: 0;
        }
        .email {
            font-size: 13px;
            color: #505060;
            margin: 6px 0 0;
        }
        .avatar-bg {
            top: 24px;
            left: 20px;
            position: absolute;
            border-radius: 50%;
            width: 64px;
            height: 64px;
        }
    }
    .charges-info {
        text-align: center;
        font-size: 12px;
        line-height: 1;
        color: #505060;
        padding-top: 14px;
        p,
        h3,
        a {
            margin: 0;
        }
        > p {
            line-height: 17px;
        }
        .date {
            font-size: 16px;
            font-weight: 400;
            margin: 8px auto 27px;
        }
        .btn {
            width: 270px;
            height: 34px;
            display: block;
            margin: auto;
            line-height: 34px;
            border-radius: 270px;
            margin-bottom: 14px;
            color: white;
            background-color: #d19f4e;
            &:hover {
                background-color: #ecbb45;
                color: black;
            }
        }
        .logout {
            font-size: 11px;
            color: #84848b;
            text-decoration: underline;
            &:hover {
                color: #d19f4e;
            }
        }
    }
}
.avatar-bg {
    > img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
    .medal {
        position: absolute;
        bottom: -5px;
        left: 0;
        left: 50%;
        transform: translateX(-50%);
    }
}
</style>

<template>
    <div class="navigation">
        <header class="fix bzb">
            <router-link :to="{name: 'homepage'}" class="logo fl"></router-link>
            <div class="search-control fl fix">
                <div class="addon fl bzb">
                    <img src="../assets/image/search.png" alt="" class="fr">
                </div>
                <input type="text" class="fl bzb" placeholder="搜索" v-model="keyword" @keyup.enter="search">
            </div>
            <div class="fr">
                <div class="info" @mouseover="showDropmenu=true" @mouseout="showDropmenu=false">
                    <img :src="userInfo.avatar" alt="" class="avatar"> {{userInfo.nickname}}
                    <transition name="fade">
                        <div class="dropmenu" v-show="showDropmenu">
                            <div class="base-info">
                                <h2 class="nickname">{{userInfo.nickname}}</h2>
                                <p class="email">{{userInfo.email}}</p>
                                <div class="avatar-bg">
                                    <img :src="userInfo.avatar" alt="">
                                    <i class="icons icon-medal-common medal" v-if="userInfo.packageType == 0"></i>
                                    <i class="icons icon-medal-vip medal" v-else></i>
                                </div>
                            </div>
                            <div class="charges-info">
                                <p>您的会员</p>
                                <h3 class="date">{{userInfo.expireTime | date('YYYY年MM月DD日')}}到期</h3>
                                <a href="/payment/#/index" target="_blank" class="btn">立即续费</a>
                                <a href="javascript:;" class="logout" @click="logout"> 退出登录</a>
                            </div>
                        </div>
                    </transition>
                </div>
                <router-link class="setting" to="/setting">
                    <i class="icons icon-setting"></i>
                    <!-- <div class="tip">&nbsp;此功能正在开发中，敬请期待！</div> -->
                </router-link>
                <router-link class="feedback" :to="{name: 'write', params: {addr: ['webmaster@vip.sohu.com']}}">常见反馈</router-link>
            </div>
        </header>
        <nav>
            <ul>
                <router-link to="/homepage" tag="li" class="tab">首页</router-link>
                <router-link to="/mail/" tag="li" class="tab">邮件</router-link>
                <router-link to="/contact/" tag="li" class="tab">通讯录</router-link>
                <!-- <router-link to="/vip" tag="li" class="tab">贵宾区</router-link> -->
                <router-link to="/attach/" tag="li" class="tab">文件管理</router-link>
            </ul>
        </nav>
    </div>
</template>

<script>
import $ from 'jquery'
import { mapState } from 'vuex'
import { logout } from '@/service/homeService'
import router from '@/router/index'
import utils from '@/common/utils'

export default {
    name: "navbar",
    data() {
        return {
            keyword: "",
            mail: false,
            showDropmenu: false
        };
    },
    computed: {
        ...mapState({
            userInfo: state => state.userInfo
        })
    },
    created:function(){
        this.keyword=this.$route.query.keyword||''
    },
    methods: {
        search() {
            // console.log(encodeURIComponent(this.keyword));
            if(!this.keyword){
                this.$toast({
                   message:'请输入搜索内容',
                   theme:'warning' 
                })
               this.keyword='' 
                
            }else if(/^[~|!@#$%^&*()_+=-`,./\\|\]\[\{\};\:\'\<\>\"\?]+$/g.test(this.keyword)){
                this.$toast({
                   message:'请输入搜索内容',
                   theme: 'warning'                        
                })
               this.keyword='' 
                return 
            }         
            else{
                // this.$store.commit('SET_SEAECH_TEXT',this.keyword)
                this.$router.push({name:'search',query:{keyword:this.keyword,_t:+Date.now()}})
            }
        },
        logout() {
            logout().then(res => {
                utils.setCookie("lt_ui_vip", '', undefined, '.vip.sohu.com')
                localStorage.clear()
                this.$store.commit('SAVE_SKIN', {})
                $('.skin').remove()
                router.replace({
                    path: '/login'
                })
            })
        }
    },
    watch:{
        '$route':function(){
            if(this.$route.name.indexOf('search')==-1){
               this.keyword='' 
            }
        },
        'keyword':function(){
            this.keyword=this.keyword.trim()
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/navbar.vue